import React from 'react';
import clsx from 'clsx';

import styles from './Menu.module.scss';

import type { StandardProps } from '../../types/common';

export interface MenuLinkProps extends StandardProps {
  /**
   * Determines whether the link is active
   */
  isActive?: boolean;
}

export const MenuLink = ({
  children,
  className,
  isActive = false,
}: MenuLinkProps): JSX.Element => {
  return React.cloneElement(children as React.ReactElement, {
    className: clsx(className, styles['hds-menu__link'], {
      [styles['is-active']]: isActive,
    }),
  });
};
